import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

interface IWrapperProps {
  pdfExport?: boolean;
  pipelineSelected?: boolean;
}

export const Wrapper = styled.div`
  height: 200px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  position: relative;
  box-shadow: ${(props: IWrapperProps) =>
    !props.pdfExport && "rgb(220, 220, 220) 0px 0px 15px"};
  margin: ${(props: IWrapperProps) => !props.pdfExport && "0 10px"};
  overflow: hidden;
  transform: ${(props: IWrapperProps) =>
    props.pdfExport && "scale(0.75) translateX(-39px) translateY(1px)"};
  transform: ${(props: IWrapperProps) =>
    props.pdfExport &&
    props.pipelineSelected &&
    "scale(0.75) translateX(-80px) translateY(-1px)"};
  max-width: ${(props: IWrapperProps) => props.pdfExport && "620px"};

  &.animated.delay-3 {
    animation-delay: 0.45s;
  }

  ${mediaMaxWidth.mediumDesktop} {
    margin: ${(props: IWrapperProps) => !props.pdfExport && "10px 20px"};
    height: ${(props: IWrapperProps) => !props.pdfExport && "unset"};
  }

  ${mediaMaxWidth.phone} {
    margin: ${(props: IWrapperProps) => !props.pdfExport && "10px"};
  }
`;

interface IChartsProps {
  pdfExport?: boolean;
}

export const Charts = styled.div`
  display: flex;
  flex: 1;

  ${mediaMaxWidth.phone} {
    flex-direction: ${(props: IChartsProps) => !props.pdfExport && "column"};
  }
`;

export const Chart = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;

  &.animated.delay-3 {
    animation-delay: 0.45s;
  }

  ${mediaMaxWidth.phone} {
    margin: 20px 0;
  }
`;

export const ChartName = styled.div`
  z-index: 1;
  font-size: 0.9em;
  position: absolute;
  bottom: 10px;

  ${mediaMaxWidth.phone} {
    bottom: 5px;
  }
`;
